jQuery(document).ready(function ($) {
  $(document).on("click", ".js-contact-btn a", function (e) {
    e.preventDefault()
    $("#contactModal").modal({
      maxWidth: 1212,
      opacity: 50,
      overlayClose: true,
      autoResize: true,
      overlayCss: { backgroundColor: "#000" },
      closeClass: "simplemodal-close",
      closeHTML:
        '<a id="simplemodal_close" href="#"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20" fill="none"><path d="M15.625 4.375L4.375 15.625" stroke="#313233" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.625 15.625L4.375 4.375" stroke="#313233" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></a>',
      onClose: function (dialog) {
        $("body").removeClass("modal-open")
        $("#contactModal .simplemodal-close").fadeOut(200)
        dialog.data.fadeOut(300, function () {
          $.modal.close()
        })
      },
      onOpen: function (dialog) {
        $("body").addClass("modal-open")
        dialog.overlay.fadeIn(100, function () {
          dialog.data.slideDown(100, function () {
            dialog.container.fadeIn(300)
          })
        })

        const $inputs = jQuery(".modal .wpcf7 .form-group .form-control")
        const $submit = jQuery(".wpcf7 .wpcf7-submit")
        // $submit.prop('disabled', true)

        // console.log('$inputs', $inputs)

        $inputs.on("change input", function () {
          const emptyInputs = $inputs.filter((index, element) => {
            return (
              jQuery(".modal .wpcf7 .wpcf7-not-valid-tip").length === 0 &&
              element.value.trim() === ""
            )
          }).length

          // console.log('emptyInputs', emptyInputs)

          // if (emptyInputs === 0) {
          //   $submit.prop('disabled', false)
          // } else {
          //   $submit.prop('disabled', true)
          // }
        })

        setTimeout(() => {
          const myForm = document.querySelector(".wpcf7-form")

          console.log(wpcf7)

          if (typeof wpcf7 === "undefined") {
            wpcf7.init(myForm)
          } else {
            console.log("Contact Form 7 is loaded.")
          }
        }, 1500)
      },
    })
  })

  document.addEventListener(
    "wpcf7mailsent",
    function (event) {
      // console.log(event.detail.contactFormId)
      if (359 === event.detail.contactFormId || 1074 === event.detail.contactFormId) {
        $("#modalSubscribeThanks").modal({
          maxWidth: 1212,
          opacity: 50,
          overlayClose: true,
          overlayCss: { backgroundColor: "#000" },
          closeClass: "simplemodal-close",
          closeHTML:
            '<a id="simplemodal_close" href="#"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20" fill="none"><path d="M15.625 4.375L4.375 15.625" stroke="#313233" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.625 15.625L4.375 4.375" stroke="#313233" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></a>',
          onClose: function (dialog) {
            $("body").removeClass("modal-open")
            $("#modalSubscribeThanks .simplemodal-close").fadeOut(200)
            dialog.data.fadeOut(300, function () {
              $.modal.close()
            })
          },
          onOpen: function (dialog) {
            $("body").addClass("modal-open")
            dialog.overlay.fadeIn(100, function () {
              dialog.data.slideDown(100, function () {
                dialog.container.fadeIn(300)
              })
            })
          },
        })
      }
    },
    false
  )

  // JavaScript to show/hide popup and set cookie
  window.onload = function () {
    var cookiePopup = document.getElementById("cookies_modal")
    var closeButton = document.querySelectorAll("#cookies_modal .wp-block-button__link")[0]

    // TODO: Alternatively, create a custom button
    if (closeButton) {
      closeButton.setAttribute("role", "button");
    }

    var closeButtons = document.querySelectorAll(".simplemodal-close a");
    for (var i = 0; i < closeButtons.length; i++) {
      closeButtons[i].setAttribute("role", "button")
    }

    // Check if cookie is set
    if (document.cookie.indexOf("cookie_accepted") < 0) {
      cookiePopup.classList.remove("hide")
    }

    // Set cookie when close button is clicked
    // console.log('closeButton', closeButton)
    if (closeButton) {
      closeButton.onclick = function () {
        document.cookie = "cookie_accepted=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/"
        cookiePopup.style.display = "none"
      }
    }
  }
})
